import { render, staticRenderFns } from "./SourceForm.vue?vue&type=template&id=7698a5cb"
import script from "./SourceForm.vue?vue&type=script&lang=js"
export * from "./SourceForm.vue?vue&type=script&lang=js"
import style0 from "./SourceForm.vue?vue&type=style&index=0&id=7698a5cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports